export function chatTagScript() {
  return <script type="application/javascript">
    {`
      (function () {
        var chatbot_id = 'buyee_bot_cht'; var d = document; var w = window; function loadWidget() {
          var script = document.createElement('script'); script.type = 'text/javascript'; script.async = true; script.src = 'https://buyeecht.aiagentbot.com/chatbot/integration?id=' + chatbot_id;
          var ss = document.getElementsByTagName('script')[0]; ss.parentNode.insertBefore(script, ss);
        } if (d.readyState == 'complete') { loadWidget(); } else { if (w.attachEvent) { w.attachEvent('onload', loadWidget); } else { w.addEventListener('load', loadWidget, false); } }
      })();
      
      (function(){ var widget_id = 'BR47GXqPHB';var d=document;var w=window;function l(){var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true;s.src = '//code.jivosite.com/script/widget/'+widget_id; var ss = document.getElementsByTagName('script')[0]; ss.parentNode.insertBefore(s, ss);}if(d.readyState=='complete'){l();}else{if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
    `}
  </script>
}
